import React from 'react'
import AppNavbar from "../views/AppNavbar";

export default function AboutPage() {
  return (
    <div className='aboutPageRoot'>
      <AppNavbar active='about'/>

    </div>
  )
}
